import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";
import { PaginationInfo } from "components/CRPComponents/Tables/GenericTable/types";

export const GET_ALL_QUERY = print(gql`
  query Logs($page: Int, $perPage: Int, $search: String, $category: CategoryEnum) {
    Logs(page: $page, perPage: $perPage, search: $search, category: $category) {
      items {
        id
        origin
        content
        category
        userId
        createdAt
      }
      paginationInfo {
        page
        perPage
        hasMore
        totalPages
        totalData
        nextPage {
          page
          perPage
        }
      }
    }
  }
`);

export interface GetAllItem {
  id: string;
  origin: string;
  content: string;
  category: string;
  userId?: string;
  createdAt: Date;
}

export const responseGetAllKey = "Logs";

export interface GetAllGql {
  [responseGetAllKey]: {
    items: GetAllItem[];
    paginationInfo: PaginationInfo;
  };
}
